export default [
  'Kanto',
  'Johto',
  'Hoenn',
  'Sinnoh'
]
